export const STORAGE_KEY_THEME = 'eu-theme'
export const STORAGE_KEY_TOKEN = 'eu-token'
export const STORAGE_KEY_LOCALE = 'eu-locale'
export const STORAGE_KEY_USERNAME = 'eu-username'
export const STORAGE_KEY_PASSWORD = 'eu-password'
export const STORAGE_KEY_REMEMBER_ME = 'eu-remember-me'
export const STORAGE_KEY_TABLE_CONFIG = 'eu-table-config'
export const REQUEST_HEADER_TOKEN = 'eutoken'
export const ALL_PERMISSION = '*'
export const ALL_ROLE = '*'
export const STORAGE_KEY_READ_MESSAGE = '_eu_message_read'
export const EU_FRONT_KEY = 'vue2'

/**
 * 表格中“操作”列的字段名
 * @type {string}
 */
export const EU_TABLE_COLUMN_FIELD_OPERATION = '_x_operation'
